module.exports = __webpack_public_path__ + "img/transfer.6723fc1f.svg";